import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rubiks.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7d8996f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rubiks Cube",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Math Attack! ", -1))

import {
        ref,
        Ref,
        watch
    } from 'vue'
    import {
        useRoute,
        RouteLocationNormalizedLoaded
    } from 'vue-router'
    import ScoreBoard from './ScoreBoard.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route: RouteLocationNormalizedLoaded = useRoute()
    const shouldShow: Ref<boolean> = ref(false)

    watch(() => route.path, (newPath, oldPath) => {
        if (
            route.path === '/question' && 
            newPath !== oldPath
        ) {
            shouldShow.value = true
        } else if (
            route.path !== '/question' && 
            newPath !== oldPath
        ) {
            shouldShow.value = false
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("section", null, [
      _createVNode(_component_RouterLink, { to: "/home" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, { to: "/home" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    (shouldShow.value)
      ? (_openBlock(), _createBlock(ScoreBoard, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})